exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-side-preview[data-v-2c8f9f02]{position:fixed!important;overflow-y:scroll;height:-webkit-fill-available;margin-bottom:25px;width:350px}.hoversquares[data-v-2c8f9f02]:hover{cursor:pointer}.activesquares[data-v-2c8f9f02],.hoversquares[data-v-2c8f9f02]:hover{border:2px solid #6ca7ff!important;background:#e5f1fc!important}@media (min-width:992px){.preview-display-status[data-v-2c8f9f02]{display:block!important}}@media (max-width:1199px){.right-side-preview[data-v-2c8f9f02]{width:290px}}@media (max-width:991px){.right-side-preview[data-v-2c8f9f02]{top:0;left:0;z-index:9999999;width:100%;height:100%;overflow:hidden;outline:0;background:#fff;padding:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c8f9f02","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/edit-saved-design.vue
// module id = 63
// module chunks = 0